import { ThreadsSocketSchema } from 'apps/chat/interfaces/threadsSocketSchema'
import {
  bulkDeleteSubscriberData,
  hideSubscriberModal,
  updateCurrentSubscriber,
  updateExportingStatus,
} from 'common/audience/actions/audienceActions'
import { updateImportStatus } from 'common/audience/actions/audienceThunks'
import { getCurrentUser } from 'common/audience/selectors/audienceSelectors'
import { getCanSubscribersBulkDeletion } from 'common/core/selectors/appSelectors'
import {
  ImportUnifiedSubscribersStatusEventSchema,
  NotifySubscribersDeletedEventSchema,
  SubscriberExportDataStatusEventSchema,
} from 'shared/api/requests/audience/schemas'
import { isPathnameInclude, navigatePollyfill } from 'utils/router/tools'
import {
  accountNotificationsListener,
  anotherTabNotificationsListener,
} from 'utils/services/notificationsService'
import { linkURL } from 'utils/url'

import { ISubscriber } from '../components/UserModal/interfaces'

anotherTabNotificationsListener.on(SubscriberExportDataStatusEventSchema, (data, dispatch) => {
  dispatch(updateExportingStatus(data))
})

anotherTabNotificationsListener.on(
  // before this change, schema was defined as SubscriberUpdatedEventSchema, which is not correct
  // we receive this socket event both in audience AND in inbox
  ThreadsSocketSchema.subscriberUpdated,
  (data, dispatch, getState) => {
    const state = getState() as RootState
    const currentUser = getCurrentUser(state)
    if (data.model.user_id !== currentUser?.user_id) return

    dispatch(
      updateCurrentSubscriber({
        subscriber: data.model as unknown as ISubscriber,
      }),
    )
  },
)

anotherTabNotificationsListener.on(
  NotifySubscribersDeletedEventSchema,
  (data, dispatch, getState) => {
    const state = getState() as RootState
    const isSubscribersNewDeletionEnabled = getCanSubscribersBulkDeletion(state)

    if (!isSubscribersNewDeletionEnabled) return

    const deletedSubscribersIds = data.model.subscribers
    const currentUserId = getCurrentUser(state)?.user_id
    const isCurrentUserOpen = currentUserId ? deletedSubscribersIds.includes(currentUserId) : false

    if (isCurrentUserOpen) {
      dispatch(hideSubscriberModal())
      // If a user is in Inbox or somewhere else out of the Audience page and deletes a contact, we don't need to redirect them to the Audience page
      if (!isPathnameInclude(`/subscribers/${currentUserId}`)) return
      navigatePollyfill(linkURL('/subscribers'))
    }

    dispatch(
      bulkDeleteSubscriberData({
        subscribers: deletedSubscribersIds,
        isCurrentUserOpen,
      }),
    )
  },
)

accountNotificationsListener.on(ImportUnifiedSubscribersStatusEventSchema, (data, dispatch) => {
  const { progress, done, data: progressInfo } = data

  if (Array.isArray(progressInfo)) {
    return
  }

  const { total_count_failed, total_count_imported, total_count_merged, tier_upgraded } =
    progressInfo
  dispatch(
    updateImportStatus({
      progress,
      done,
      totalCountFailed: total_count_failed,
      totalCountImported: total_count_imported,
      totalCountMerged: total_count_merged,
      isTierUpgraded: tier_upgraded,
    }),
  )
})
